import EntityPermissionsMapperBinder from "logic/permissions/EntityPermissionsMapper";
const supportedTypes = /* @__PURE__ */ new Set(["dashboard", "event_procedure", "event_procedure_step"]);
const securityEntityPermissionsMapper = {
  mapForIdAndType(id, type) {
    if (id.startsWith("graylog-security-views__") && supportedTypes.has(type)) return "graylog_security:";
    return void 0;
  },
  mapForType(type) {
    if (supportedTypes.has(type)) return `${type}s:`;
    return void 0;
  }
};
EntityPermissionsMapperBinder.register(securityEntityPermissionsMapper);
export default securityEntityPermissionsMapper;
